/* eslint-disable no-case-declarations */

import {
  LOADING_ADDRESSES,
  LOADING_ADDRESSES_SUCCESS,
  LOADING_ADDRESSES_ERROR,

  FINDING_ADDRESSES,
  FINDING_ADDRESSES_SUCCESS,
  FINDING_ADDRESSES_ERROR,

  GETTING_POSITION_TO_ADDRESS,
  GETTING_POSITION_TO_ADDRESS_SUCCESS,
  GETTING_POSITION_TO_ADDRESS_ERROR,
} from '../actions/addresses';
  
const initialState = {
  addressList: [],
  findList: [],
  position_to_address: {},
  loading: false,
};
  
const AddressesReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOADING_ADDRESSES:
        return { ...state, loading: true };
  
      case LOADING_ADDRESSES_SUCCESS:
        return {
          ...state,
          loading: false,
          addressList: action.payload,
        };

      case FINDING_ADDRESSES:
        return { ...state, loading: true };
  
      case FINDING_ADDRESSES_SUCCESS:
        return {
          ...state,
          loading: false,
          findList: action.payload,
        };

      case GETTING_POSITION_TO_ADDRESS:
        return { ...state, loading: true };

      case GETTING_POSITION_TO_ADDRESS_SUCCESS:
        return {
          ...state,
          loading: false,
          position_to_address: action.payload,
        };

      default:
        return state;
    }
  };
  
  export default AddressesReducer;
  